export function displayBillingQuantityAndCycle(cycle: string | undefined, quantity: number | undefined) {
  if (cycle && cycle !== "-") {
    const displayCycle = quantity && quantity < 2 ? cycle.slice(0, -1) : cycle;
    const firstLetterToUppercase = displayCycle.charAt(0).toUpperCase() + displayCycle.slice(1);
    return `${quantity} ${firstLetterToUppercase}`;
  } else {
    return "-";
  }
}
